/* RESPONSIBLE TEAM: team-phone */

import Model, { attr } from '@ember-data/model';

export interface PhoneNumberUsage {
  phone_number: string;
  iso_country: string;
  sub_category: string;
  name: string;
  units: number;
  price_in_cent: number;
}

export interface InboundCallUsage {
  sub_category: string;
  iso_country: string;
  units: number;
  price_in_cent: number;
}

export interface OutboundCallUsage {
  sub_category: string;
  iso_country: string;
  units: number;
  price_in_cent: number;
}

export interface RecordingUsage {
  iso_country: string;
  units: number;
  price_in_cent: number;
  sub_category: string;
}

export interface MessengerCallUsage {
  iso_country: string;
  units: number;
  price_in_cent: number;
  sub_category: string;
}

export default class CallingUsageData extends Model {
  @attr('array') declare phone_numbers: PhoneNumberUsage[];
  @attr('array') declare inbound_calls: InboundCallUsage[];
  @attr('array') declare outbound_calls: OutboundCallUsage[];
  @attr('array') declare recordings: RecordingUsage[];
  @attr('array') declare messenger_calls: MessengerCallUsage[];
  @attr('string') declare from_date: string;
  @attr('string') declare to_date: string;
}
